module.exports = __webpack_public_path__ + "images/icons/icon-orders-a00cc8c2.svg";